import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const invoiceSlice = createSlice({
  name: "invoiceData",
  initialState: {
    invoicePaidData: [],
    invoiceUnpaidData: [],
    arReportData: [],
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },

  reducers: {
    setInvoicePaidData: (state, action) => {
      state.invoicePaidData = action.payload; // for cumulative credits
    },
    setInvoiceUnpaidData: (state, action) => {
      state.invoiceUnpaidData = action.payload; // for cumulative credits
    },
    setARReportData: (state, action) => {
      state.arReportData = action.payload; // for cumulative credits
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

export const {
  setErrorMessage,
  setErrorStatusCode,
  setDataFetchingStatus,
  setInvoicePaidData,
  setInvoiceUnpaidData,
  setARReportData,
} = invoiceSlice.actions;

//redux function For getting invoice data

export const getInvoiceData = (studentId, contactId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`invoices/${studentId}/${contactId}`)
    .then((response) => {
      dispatch(setInvoicePaidData(response.data.paidInvoice));
      dispatch(setInvoiceUnpaidData(response.data.unpaidInvoice));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getARReport = (studentId, contactId) => (dispatch) => {
  // dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`arreport/${studentId}/${contactId}`)
    .then((response) => {
      console.log(response);
      dispatch(setARReportData(response.data.arReportInvoice));
      // dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveFileUploadData = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("/invoices/proof", formData, {})
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
      dispatch(getInvoiceData(formData.studentId));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

//End of redux Function For getting invoice data

export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};

export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export default invoiceSlice.reducer;
